<template>
    <!-- Panneau d'encaissement : en-tête, onglets de paiement à gauche, panier et totaux à droite -->
    <div class="ckp">
        <slot name="overlay-header"></slot>
        <div class="ckp-body">
            <div class="ckp-left">
                <div class="nav ckp-tabs" role="tablist">
                    <button type="button" class="ckp-tab active" id="current-sale-tab" data-bs-toggle="tab" data-bs-target="#current-sale" role="tab" aria-controls="current-sale" aria-selected="true">Vente en cours</button>
                    <button type="button" class="ckp-tab" id="voucher-tab" data-bs-toggle="tab" data-bs-target="#voucher" role="tab" aria-controls="voucher" aria-selected="false">Bons cadeau</button>
                    <button type="button" class="ckp-tab" id="avoir-tab" data-bs-toggle="tab" data-bs-target="#avoir" role="tab" aria-controls="avoir" aria-selected="false">Avoirs</button>
                    <button type="button" class="ckp-tab" id="serie-treatment-tab" data-bs-toggle="tab" data-bs-target="#serie-treatment" role="tab" aria-controls="serie-treatment" aria-selected="false">Abonnements et cures</button>
                </div>
                <div class="tab-content">
                    <div class="tab-pane fade show active" id="current-sale" role="tabpanel" aria-labelledby="current-sale-tab">
                        <slot name="payment-component"></slot>
                    </div>
                    <div class="tab-pane fade" id="voucher" role="tabpanel" aria-labelledby="voucher-tab">
                        <slot name="voucher-tab"></slot>
                    </div>
                    <div class="tab-pane fade" id="avoir" role="tabpanel" aria-labelledby="avoir-tab">
                        <slot name="avoir-tab"></slot>
                    </div>
                    <div class="tab-pane fade" id="serie-treatment" role="tabpanel" aria-labelledby="serie-treatment-tab">
                        <slot name="serie-treatment-tab"></slot>
                    </div>
                    <div class="tab-pane fade" id="waiting-sales" role="tabpanel">
                        <slot name="waiting-sales-tab"></slot>
                    </div>
                </div>
            </div>
            <div class="ckp-right">
                <slot name="card-component"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>
